import axios from 'axios';
import AddEditPatientDocument from 'components/clinical-data/AddEditPatientDocument';
import { DocumentActionButton } from 'components/clinical-data/RequiresActionDocumentList';
import FormModalContentContainer from 'components/layout/FormModalContentContainer';
import LoaderComponent from 'components/LoaderComponent';
import React, { useRef } from 'react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Modal } from 'semantic-ui-react';
import { getUpsertPatientDocument } from 'services/patientRecordServices';
import { PatientCdrDocumentDto, PatientDto, UpsertPatientMedicalDocumentDto } from 'ts-types/api.types';
import { withRouterWorkaround } from 'utils/workaroundUtils';

interface Props extends MessageSourceProps {
  document: PatientCdrDocumentDto;
  patient: PatientDto;
  onSave: (successfullyUploaded: boolean, documentId: number | undefined) => void;
  handleError: (errorData: any) => void;
}

const CdrDocumentAddEditModal = (props: Props) => {

  const {getMessage} = props;

  const cancelTokenSource = useRef(axios.CancelToken.source());

  const [loadingData, setLoadingData] = React.useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);

  const [upsertDocument, setUpsertDocument] =
      React.useState<UpsertPatientMedicalDocumentDto | undefined>(undefined);

  const openModal = () => {

    const {document} = props;

    const {documentId, patientId} = document;

    setLoadingData(true);
    setModalOpen(true);
    getUpsertPatientDocument(patientId, documentId, cancelTokenSource.current)
        .then(response => {
          setUpsertDocument(response);
        })
        .catch((e: any) => {

          setModalOpen(false);

          e.response
          && e.response.data
          && props.handleError
          && props.handleError(e.response.data)
        })
        .finally(() => {
          setLoadingData(false);
        });
  };

  const closeModal = () => {
    setModalOpen(false);
    setUpsertDocument(undefined);
  };

  const onSaveUpsertForm = async (
      successfullyUploaded: boolean,
      documentId: number | undefined) => {

    props.onSave && props.onSave(successfullyUploaded, documentId);
    closeModal();
  }

  if (loadingData) {
    return <LoaderComponent/>
  }

  return <>
    <DocumentActionButton
        iconName="edit"
        popupMessage="msgEdit"
        onClick={openModal}
    />

    {
        modalOpen
        && <Modal
            centered={false}
            open={modalOpen}
            onClose={closeModal}
            closeOnDimmerClick={false}
        >
          <Modal.Header>
            {getMessage("patientDocument.header")}
          </Modal.Header>
          <FormModalContentContainer>
            <AddEditPatientDocument
                onCancel={closeModal}
                onSave={onSaveUpsertForm}
                patientDocument={upsertDocument}
                patientId={props.document.patientId}
                patient={props.patient}
                documentId={props.document.id}
            />
          </FormModalContentContainer>
        </Modal>
    }
  </>;
}

export default withRouterWorkaround(
    withMessages(
        CdrDocumentAddEditModal));
